import { EncounterNode as EncounterSchema } from '@seen/core/tiptap/schema'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { EncounterNodeView } from '#src/components/rich-text-editor/EncounterNode/EncounterNodeView.tsx'

export const EncounterNode = EncounterSchema.extend({
  addNodeView() {
    return ReactNodeViewRenderer(EncounterNodeView, { className: 'group' })
  },
})
